import { gql } from '@apollo/client';

export const UPSERT_AUDIT_DECISION = gql`
  mutation UpsertAuditDecision($input: UpsertAuditDecisionInput!) {
    upsertAuditDecision(input: $input) {
      id
      auditItemId
      auditSessionId
      auditorId
      auditorName
      timestamp
      updatedAt
      isSelected
      selectedBy
      selectedAt
      isCurrentUser
      languageCorrect
      transcriptionCorrect
      correctedTranscription
      ocrCorrect
      correctedOcr
      originalLabels {
        name
        severity
      }
      correctedLabels {
        name
        severity
      }
      comments
      labelsCorrect
      policiesCorrect
      triggeredPolicyAssessments {
        policyId
        policyName
        isCorrect
        comments
      }
      nonTriggeredPolicyAssessments {
        policyId
        policyName
        isCorrect
        comments
      }
      # Return the complete audit item with all decisions for efficient cache update
      auditItem {
        id
        type
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
        auditSessionId
        status
        position
        decisionsCount
        selectedDecisionId
        contentSnapshot {
          audioFileUrl
          transcription
          language
          topic
          contentType
          classificationType
          classificationResults {
            name
            severity
          }
          metadata
          triggeredPolicies {
            id
            name
            communityId
            description
            isEnabled
            labels {
              labelId
              severity
            }
          }
          nonTriggeredPolicies {
            id
            name
            description
            communityId
            isEnabled
            labels {
              labelId
              severity
            }
          }
          slmModelVersion
          slmPromptVersion
          quicktxtModelVersion
        }
        kustoReference {
          communityId
          subjectId
          timestamp
        }
        decisions {
          id
          auditItemId
          auditSessionId
          auditorId
          auditorName
          timestamp
          updatedAt
          isSelected
          selectedBy
          selectedAt
          isCurrentUser
          languageCorrect
          transcriptionCorrect
          correctedTranscription
          ocrCorrect
          correctedOcr
          originalLabels {
            name
            severity
          }
          correctedLabels {
            name
            severity
          }
          comments
          labelsCorrect
          policiesCorrect
          triggeredPolicyAssessments {
            policyId
            policyName
            isCorrect
            comments
          }
          nonTriggeredPolicyAssessments {
            policyId
            policyName
            isCorrect
            comments
          }
        }
      }
    }
  }
`;
